import React, { useState, useEffect } from "react";
import { Box, Tabs, Tab, Grid, Typography, IconButton, Tooltip } from "@mui/material";
import { Employee } from "../models";
import { useParams } from "react-router-dom";
import EmployeeEdit from "./EmployeeEdit";
import DriverEdit from "./DriverEdit";
import employeeService from "services/employeeService";
import Shifts from "./Shifts";
import InfoIcon from "@mui/icons-material/Info";

const EmployeeTabs = () => {
  const [activeTab, setActiveTab] = React.useState(0);
  const [employee, setEmployee] = useState<Employee>();
  const { id } = useParams();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (!employee && !loading) {
      setLoading(true);
      employeeService.getEmployee(id).then((results) => {
        setEmployee(results);
        if (!results.driver) setActiveTab(1);
        setLoading(false);
      });
    }
  }, []);

  const reloadEmployee = async (): Promise<any> => {
    setLoading(true);
    try {
      const results = await employeeService.getEmployee(id);
      setEmployee(results);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };
  return (
    <>
      {employee && (
        <Grid item xs={12} sx={{ padding: 2 }}>
          <Box>
            <Grid container spacing="2">
              <Grid item xs={12} md={4}>
                {" "}
                <Typography sx={{ fontSize: 18 }} color="text.secondary" gutterBottom>
                  <b>Employee Name:</b> {employee.firstName} {employee.lastName}{" "}
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                {" "}
                <Typography sx={{ fontSize: 18 }} color="text.secondary" gutterBottom>
                  <b>Employee Number:</b> {employee.employeeNumber}
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography sx={{ fontSize: 18 }} color="text.secondary" gutterBottom>
                  <b>
                    Employee Code{" "}
                    <Tooltip title="Go to Paycom">
                      <IconButton size="small">
                        <InfoIcon />
                      </IconButton>
                    </Tooltip>
                    :
                  </b>{" "}
                  {employee.employeeCode ? (
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={`https://www.paycomonline.net/v4/cl/web.php/employee/changes/forms/1?eecode=${employee.employeeCode}`}
                    >
                      {employee.employeeCode}
                    </a>
                  ) : (
                    "N/A"
                  )}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      )}
      <Box sx={{ borderBottom: 1, borderColor: "divider", padding: 2 }}>
        {employee?.driver && (
          <Tabs value={activeTab} onChange={handleChange} aria-label="basic tabs example">
            <Tab
              className={activeTab == 0 ? "tab tab-active" : "tab"}
              label="Driver"
              id="driver-tab"
              aria-controls="driver-tab-panel"
            />
            <Tab
              className={activeTab == 1 ? "tab tab-active" : "tab"}
              label="Employee"
              id="employee-tab"
              aria-controls="employee-tab-panel"
            />
            <Tab
              className={activeTab == 2 ? "tab tab-active" : "tab"}
              label="Availability"
              id="availability-tab"
              aria-controls="availability-tab-panel"
            />
          </Tabs>
        )}
        {employee?.driver && (
          <div id="driver-tab-panel" hidden={activeTab !== 0}>
            <DriverEdit employee={employee!} setEmployee={setEmployee} reloadEmployee={reloadEmployee} />
          </div>
        )}
        <div id="employee-tab-panel" hidden={activeTab !== 1}>
          <EmployeeEdit employee={employee!} setEmployee={setEmployee} reloadEmployee={reloadEmployee} />
        </div>
        {employee?.driver && (
          <div id="availability-tab-panel" hidden={activeTab !== 2}>
            <Shifts
              crewShifts={employee.driver.crewShifts}
              driverId={employee.driver.driverId}
              reloadEmployee={reloadEmployee}
            />
          </div>
        )}
      </Box>
    </>
  );
};

export default EmployeeTabs;
